import { useState, useEffect, useCallback } from 'react';
import { isEligibleForFeedback, markFeedbackDismissed } from '../utils/analytics';

/**
 * Hook that checks feedback survey eligibility every 30 seconds.
 * Returns { showSurvey, dismissSurvey } for the FeedbackSurvey component.
 */
export default function useFeedbackSurvey() {
  const [showSurvey, setShowSurvey] = useState(false);

  useEffect(() => {
    // Check immediately on mount
    if (isEligibleForFeedback()) {
      setShowSurvey(true);
      return;
    }

    // Then poll every 30 seconds
    const interval = setInterval(() => {
      if (isEligibleForFeedback()) {
        setShowSurvey(true);
        clearInterval(interval);
      }
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const dismissSurvey = useCallback(() => {
    setShowSurvey(false);
    markFeedbackDismissed();
  }, []);

  return { showSurvey, dismissSurvey };
}
